import en from "../locales/en.json";
import gu from "../locales/gu.json";

export const SUPPORTED_LOCALES = ["en", "gu"];
export const DEFAULT_LOCALE = "en";
const STORAGE_KEY = "app_locale";

const translations = {
  en,
  gu,
};

const getStoredLocale = () => {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored;
    }
  } catch (error) {
    // ignore storage access issues
  }
  return null;
};

let currentLocale = getStoredLocale() || DEFAULT_LOCALE;

const setCurrentLocale = (locale) => {
  const nextLocale = SUPPORTED_LOCALES.includes(locale)
    ? locale
    : DEFAULT_LOCALE;
  if (nextLocale === currentLocale) {
    return currentLocale;
  }
  currentLocale = nextLocale;
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, nextLocale);
      window.location.reload();
    } catch (error) {
      // ignore storage failures
    }
  }
  return currentLocale;
};

const getValue = (obj, path) =>
  path.split(".").reduce((acc, part) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
      return acc[part];
    }
    return undefined;
  }, obj);

const translate = (key, localeOverride) => {
  const activeLocale = localeOverride || currentLocale;
  const localeValue = getValue(translations[activeLocale] || {}, key);
  if (typeof localeValue === "string") return localeValue;

  const fallbackValue = getValue(translations.en || {}, key);
  if (typeof fallbackValue === "string") return fallbackValue;

  return key;
};

export const setLocale = (locale) => setCurrentLocale(locale);
export const getLocale = () => currentLocale;
export const t = (key, locale) => translate(key, locale);

export const loadInitialLocale = () => setCurrentLocale(currentLocale);
